import React, { useEffect, useState } from "react";
import { EmptyVersion, VersionType } from "../types/Version";
import axios from "axios";

type Props = {
  children: React.ReactChild;
};

type VersionContextType = {
  version: VersionType;
  [key: string]: any;
};

export const VersionContext = React.createContext<VersionContextType>({
  version: EmptyVersion,
  setCurrentVersion: (version: VersionType) => {},
});

const VersionContextProvider = (props: Props) => {
  const [version, setVersion] = useState<VersionType>(EmptyVersion);
  const [selectLoading, setSelectLoading] = useState<boolean>(false);

  const setCurrentVersion = (version: VersionType) => {
    localStorage.setItem("selectedVersion", JSON.stringify(version));
    if (version.version_number !== 0) {
      setSelectLoading(true);
      document.body.classList.add("loading-cursor");

      axios
        .put(`/version/select`, { version_number: version.version_number })
        .catch(() => {})
        .finally(() => {
          setSelectLoading(false);
          document.body.classList.remove("loading-cursor");
        });
    }
    setVersion(version);
  };

  return (
    <VersionContext.Provider
      value={{
        version,
        setCurrentVersion,
        selectLoading,
      }}
    >
      {props.children}
    </VersionContext.Provider>
  );
};

export default VersionContextProvider;
